var _style, _path, _path2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 390 390",
    style: {
      enableBackground: "new 0 0 390 390"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M485.2,123.7c0,1.5,0,2.8,0,4.1c0,82.1,0,164.2,0,246.3c0,9.3,4.2,13.5,13.4,13.5c4.9,0,9.8,0,14.7,0v-264 c-7.8,0-15.7,0-23.5,0C488.4,123.7,487.1,123.7,485.2,123.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M513.3,101V90.5c-3.5,3.5-7,7-10.4,10.5C506.3,101,509.7,101,513.3,101z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M266.2,43.1c0,11,0,22.7,0,34.6c12,0,23.8,0,34.5,0C289.4,66.3,277.7,54.6,266.2,43.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195,162c-27.2,0-54.4,0-81.5,0c-8.9,0-14.6-8.2-11-15.8c2.1-4.5,5.8-6.6,10.8-6.6c11.1,0,22.2,0,33.3,0 c43.2,0,86.5,0,129.8,0c9,0,14.7,8,11.3,15.7c-2.2,4.8-6.2,6.9-11.4,6.8c-24.9,0-49.9,0-74.8,0C199.2,162,197.1,162,195,162z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195,229.5c-27.2,0-54.4,0-81.5,0c-8.9,0-14.6-8.2-11-15.8c2.1-4.5,5.8-6.6,10.8-6.6c11.1,0,22.2,0,33.3,0 c43.2,0,86.5,0,129.8,0c9,0,14.7,8,11.3,15.7c-2.2,4.8-6.2,6.9-11.4,6.8c-24.9,0-49.9,0-74.8,0C199.2,229.5,197.1,229.5,195,229.5z "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195,297c-27.2,0-54.4,0-81.5,0c-8.9,0-14.6-8.2-11-15.8c2.1-4.5,5.8-6.6,10.8-6.6c11.1,0,22.2,0,33.3,0 c43.2,0,86.5,0,129.8,0c9,0,14.7,8,11.3,15.7c-2.2,4.8-6.2,6.9-11.4,6.8c-24.9,0-49.9,0-74.8,0C199.2,297,197.1,297,195,297z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M266.2,77.7c12,0,23.8,0,34.5,0c-11.4-11.4-23.1-23.1-34.5-34.6C266.2,54.2,266.2,65.8,266.2,77.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341,91.9c0-5.1-1.6-9-5.2-12.6c-23.1-23-46-46.1-69.1-69.1c-2.7-2.7-5.9-4.8-8.8-7.2C198,3,138.1,3,78.2,3 c-4.7,1.9-9.8,3.1-14,5.8C53.8,15.5,49,25.6,49,38c0,38.7,0,77.4,0,116.1h0c0,28.7,0,65.2,0,91.5c0,35.6-0.1,71.2,0,106.8 c0,14.9,7.1,25.7,20.7,31.9c2.7,1.2,5.6,1.8,8.5,2.7c5.7,0,11.4,0,17.1,0c1.4,0,2.8,0,4.3,0c52.5,0,162.9,0,212.1,0 c2.8-0.9,5.8-1.5,8.5-2.7c13.6-6.2,20.6-17,20.7-31.9c0.1-35.6,0-71.2,0-106.8C340.9,194.4,340.9,143.2,341,91.9z M266.2,43.1 c11.5,11.5,23.2,23.2,34.5,34.6c-10.8,0-22.5,0-34.5,0C266.2,65.8,266.2,54.2,266.2,43.1z M318.5,104.6c0,82.1,0,164.2,0,246.3 c0,9.3-4.2,13.5-13.4,13.5c-47,0-155,0-205.4,0c-1.5,0-2.9,0-4.3,0c-3.5,0-6.9,0-10.4,0c-9.2,0-13.4-4.2-13.4-13.5 c0-65,0-143.1,0-208.1h0c0-34.7,0-69.4,0-104c0-9,4.3-13.3,13.3-13.3c51.6,0,103.3,0,154.9,0c1.1,0,2.2,0,4,0c0,1.4,0,2.7,0,4 c0,19.2,0,38.5,0,57.7c0,9,4.3,13.2,13.4,13.2c19,0,37.9,0,56.9,0c1.4,0,2.7,0,4.6,0C318.5,102,318.5,103.3,318.5,104.6z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.6d94d9290cdfd2fee4f299383e6afb85.svg";
export { ForwardRef as ReactComponent };